import React, {KeyboardEvent, useRef, useState} from 'react';
import Imgix from "react-imgix";
import {AVATAR_PATH, DEFAULT_PRESET_IMAGE_PATH} from "../constants";
import {PresetDM, PresetTagDM, ProfileDM, UserLikeResponse} from "../interfaces";
import {getEpochFromDate, onClickProfile} from "../services/logic-provider";
import VerifiedIcon from "../../../../ui/svg/common/verified";
import PresetVisitChain from "./preset-visit-chain";
import {isMobile, isTablet} from "../../../../domain/common";
import HeartIcon from "../../../../ui/svg/common/heart";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";
import {setUserLikeClick} from "../DAL/data-service";
import PresetIcons from "../../preset/components/preset-icons";

export interface IPresetProps {
    preset:PresetDM;
    profile:ProfileDM;
    presetTags:PresetTagDM[];
    isHandleLinked?:boolean;
    imgCdnDomain:string;
    creatorsPath:string;
    imgWidth?:number;
    imgHeight?:number;
    cancelImgLazyload?:boolean;
    presetListRef?:any;
    setShowLinkCopiedPopup:Function;
    isDarkBackground?:boolean;

}

const Preset = (props:IPresetProps) => {
    const imageContainer = useRef<HTMLDivElement>(null);
    const [showOverButtons, setShowOverButtons] = useState(false);
    const [isUserLiked, setIsUserLiked] = useState(props.preset.isUserLike);
    const [isLikeLoading, setIsLikeLoading] = useState(false);

    const [presetLikeCount, setPresetLikeCount] = useState(props.preset.likesCount);

    const isDesktopScreen = !(isMobile() || isTablet());

    const mouseOver = (evnt:any) => {
        if(isDesktopScreen && imageContainer.current !== null && imageContainer.current !== undefined){
            imageContainer.current.style.filter = 'brightness(30%)';
            setShowOverButtons(true);
        }

    }
    const mouseOut = (evnt:any) => {
        if(isDesktopScreen && imageContainer.current !== null && imageContainer.current !== undefined){
            imageContainer.current.style.filter = 'unset';
            setShowOverButtons(false);
        }

    }
    const onClickPreset = () => {
        sendGAEvent("SV Widget","Widget Chain: " + props.preset.presetName );
        window.location.href = "/studioverse/chain/" + props.preset.presetGUID;
    }

    const onClickTag = (tag : PresetTagDM) => {
        sendGAEvent("SV Widget","Widget Tag: " + tag.tagAlias);
        window.location.href = "/studioverse/chains/tag/" + tag.tagAlias;
    }
    const userLikeClick = async () => {
        if(isLikeLoading) return;
        setIsLikeLoading(true);
        let response = null;
        try {
            response = await setUserLikeClick(props.preset.presetGUID);
        }
        catch(ex){}

        if(response?.data && response.data.isValid && response.data.relatedData){
            setPresetLikeCount((response.data.relatedData as UserLikeResponse).likeObj.result);
            setIsUserLiked(!isUserLiked);
            setIsLikeLoading(false);

        }else if(response && response.statusCode && response.statusCode === 401){
            window.location.href = "/login?returnurl=" + window.location.pathname;
            setIsLikeLoading(false);
            return;
        }
    }
    const getHeartColor = () => {
        if(isUserLiked){
            return "red";
        }else if(props.isDarkBackground){
            return "white";
        }
        return "black";
    }
    const handleKeyPress = (evt: KeyboardEvent<HTMLButtonElement>) => {
        if (evt.key === 'Enter') {
            onClickPreset();
        }
    };
    return (
        <>
            <div className={`w-full ${props.isDarkBackground ? "":"bg-gray-100"} ${props.isDarkBackground ? "text-white":""}`} style={props.imgWidth ? {width:props.imgWidth + "px"}:{}}>
                <div className="preset-box w-full" >
                    <button type="button" className="preset-box-top w-full flex items-center justify-center relative"  onKeyUp={handleKeyPress}  onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
                        {showOverButtons && <PresetVisitChain preset={props.preset} presetListRef={props.presetListRef} setShowLinkCopiedPopup={props.setShowLinkCopiedPopup}/>}

                        <div className="cursor-pointer"  ref={ imageContainer } onClick={onClickPreset}>


                            {props.preset.imgExt.length > 0 ?
                                <Imgix
                                    className={`max-w-full`}
                                    src= {props.imgCdnDomain +
                                        "/images/studioverse/presets/"+
                                        props.preset.imgGUID + "." +
                                        props.preset.imgExt  + "?epoch=" + getEpochFromDate(props.preset.imgLastModified)
                                    }
                                    sizes={props.cancelImgLazyload ? "" : "auto"}
                                    width={props.imgWidth ? props.imgWidth : 400}
                                    height={props.imgHeight ? props.imgHeight : 300}
                                    imgixParams={{ fit: "crop" }}
                                    htmlAttributes={{
                                        alt: `Image for ${ props.preset.presetName }`,
                                        loading: props.cancelImgLazyload ? undefined : 'lazy',
                                    }}
                                />
                                :
                                <Imgix
                                    src= {props.imgCdnDomain + DEFAULT_PRESET_IMAGE_PATH }
                                    sizes={props.cancelImgLazyload ? "auto" :""}
                                    width={props.imgWidth ? props.imgWidth : 400}
                                    height={props.imgHeight ? props.imgHeight : 300}
                                    imgixParams={{ fit: "crop" }}
                                    htmlAttributes={{
                                        alt: `Image for ${ props.preset.presetName }`,
                                        loading: props.cancelImgLazyload ? undefined : 'lazy',
                                    }}
                                />
                            }
                        </div>

                    </button>
                    <div className={`preset-box-middle flex items-center justify-start mt-4 ${props.isDarkBackground ? "":"px-2"}`}>
                        <div className="min-w-8 w-8 h-8 mr-2">

                            {props.profile.imgExt.length > 0 ?
                                <Imgix
                                    className={`rounded-full overflow-hidden`}
                                    src= {props.imgCdnDomain + "/" +
                                        props.creatorsPath +
                                        props.profile.prfUserGUID + "." +
                                        props.profile.imgExt  + "?epoch=" + getEpochFromDate(props.profile.itemModifiedWhen)}
                                    sizes={props.cancelImgLazyload ? "auto":""}
                                    width={50}
                                    height={50}
    /*
                                    imgixParams={{ mask:"ellipse" }}
    */
                                    htmlAttributes={{
                                        alt: `${ props.profile.publicName } profile image`,
                                        loading: props.cancelImgLazyload ? undefined : 'lazy',
                                    }}
                                />
                                :
                                <Imgix
                                    src= {props.imgCdnDomain + AVATAR_PATH }
                                    sizes={props.cancelImgLazyload ? "auto":""}
                                    width={50}
                                    height={50}
                                    imgixParams={{ mask:"ellipse" ,facepad:"1.9",fit: "facearea"}}
                                    htmlAttributes={{
                                        alt: `${ props.profile.publicName } profile image`,
                                        loading: props.cancelImgLazyload ? undefined : 'lazy',
                                    }}
                                />
                            }
                        </div>
                        <div className="flex-1  w-ellipsis">
                            <div className="w-full font-medium text-sm flex items-center">
                                <div className="flex-1 flex items-center">
                                    <div className="w-ellipsis">{props.profile.publicName}</div>
                                    {props.profile.isVerified &&
                                        <div className="ml-1">
                                            <VerifiedIcon width="15px" />
                                        </div>
                                    }
                                </div>
                                <div className="pl-2 flex items-center justify-center">
                                    <span className="pr-1 text-sm">{presetLikeCount}</span>
                                    <button type="button"
                                            className="cursor-pointer"
                                            onClick={userLikeClick}
                                            style={isUserLiked ? {paddingTop:"1px"}:{}}
                                            aria-label={`Add like to ${props.profile.publicName}`}
                                    >
                                        <HeartIcon isColorFill={isUserLiked} width={isUserLiked ? "14px":"15px"} color={getHeartColor()}/>
                                    </button>
                                </div>
                            </div>
                            {props.isHandleLinked?
                                <div className="w-full text-xs text-left w-ellipsis">
                                    <button type="button" className={`cursor-pointer underline ${props.isDarkBackground ? "text-white":"text-gray-700"}`}
                                       onClick={() => onClickProfile(props.profile)}>
                                        @{props.profile.handle}
                                    </button>
                                </div>
                                :
                                <div className="w-full text-xs  text-left w-ellipsis">@{props.profile.handle}</div>
                            }
                        </div>


                    </div>
                    <div className={`preset-box-bottom w-full text-left font-medium mt-4 mb-2 pb-2 h-16 ${props.isDarkBackground ? "":"px-2"}`}>
                        <button type="button" className={`cursor-pointer no-underline ${props.isDarkBackground ? "text-white":"text-black"}`}
                              onClick={onClickPreset}>
                            <div className="flex flex-row items-start">
                                <span className="pt-1"><PresetIcons width={"15"} algType={props.preset.algType}/></span>
                                <span className="pl-1">{props.preset.presetName}</span>
                            </div>
                        </button>
                    </div>
                {/*<div className="w-ellipsis w-line-clamp-2 text-xs">*/}
                {/*    {props.presetTags.map((tag,index) => {*/}
                {/*        return <span className={`w-auto cursor-pointer pr-1 ${props.isDarkBackground ? "text-white":"text-gray-500"}`}*/}
                {/*                          key={tag.tagAlias + "_"+props.preset.presetID + +"_" + index}*/}
                {/*                          onClick={() => onClickTag(tag)}>*/}
                {/*                    {tag.tagName} {props.presetTags.length - 1 > index ? <span className="pl-1">|</span> : ""}*/}
                {/*                </span>*/}
                {/*    })}*/}

                {/*</div>*/}
                </div>
            </div>


        </>

    )
};

export default Preset;